export default __webpack_public_path__ + "static/media/400.c1641001.svg";